import { readCountrySlugFromStorage, readDefaultCountrySlugFromStorage } from './currentCountry';

/**
 * Prefix internal paths with /{country}/ when the selected country is not the default
 * (same rules as the router).
 * @param {string} path - must start with / (e.g. /services/foo/)
 */
export function withCountryPath(path) {
  let p = path || '/';
  if (!p.startsWith('/')) p = `/${p}`;
  const def = (readDefaultCountrySlugFromStorage() || '').toLowerCase().trim();
  const cur = (readCountrySlugFromStorage() || '').toLowerCase().trim();
  if (!cur || !def || cur === def) return p;
  if (p === '/') return `/${cur}/`;
  return `/${cur}${p}`;
}

/**
 * Strip optional /{country}/ when followed by /services/... (for API path matching DB service_url).
 */
export function pathWithoutCountryForServicesApi(routePath) {
  const p = routePath || '';
  const m = p.match(/^\/[^/]+(\/services\/.*)$/i);
  if (m) return m[1];
  return p;
}
